import { uuid } from "@cnx/common";

export interface DocumentWithId {
  id: string;
  blob: Blob;
  isSaved?: boolean;
  viewAdminOnly?: number;
}

export const createDocumentWithId = (blob: Blob): DocumentWithId => ({
  id: uuid(),
  blob,
});
